import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TripOrder from './components/TripOrder';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<TripOrder />} />
          <Route path="/:tripOrderId" element={<TripOrder />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
